"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaflyCompany = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class LeaflyCompany {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], LeaflyCompany.prototype, "menuIntegrationKey", void 0);
exports.LeaflyCompany = LeaflyCompany;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGVhZmx5LmpzIiwic291cmNlUm9vdCI6Ii4vc3JjLyIsInNvdXJjZXMiOlsicGFja2FnZXMvbW9kZWxzL3NyYy9sZWFmbHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHFDQUFpQztBQUVqQyxNQUFhLGFBQWE7Q0FHekI7QUFGRztJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7eURBQ0E7QUFGL0Isc0NBR0MiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb2x1bW4gfSBmcm9tIFwidHlwZW9ybVwiO1xuXG5leHBvcnQgY2xhc3MgTGVhZmx5Q29tcGFueSB7XG4gICAgQENvbHVtbih7IG51bGxhYmxlOiB0cnVlIH0pXG4gICAgbWVudUludGVncmF0aW9uS2V5OiBzdHJpbmc7XG59Il19